import {factorial, round, systemSize} from "./index";

export const calcData = (max, size, bet, stepTwoData) => {
  let c = systemSize(max, size);
  let kef=[];
  let kefArray=[];

  for (let i=0; i<max; i++){
    let buff1 = stepTwoData[`bet${i}`];
    kef.push(buff1); // прочитали коэффициенты
    kefArray.push(buff1);
  }

  let res=[];
  for (let i=0; i<max; i++) {
    let checked = stepTwoData[`betStatus${i}`];
    if (checked) {
      res.push(1);
    } else {
      res.push(3);
    }
  }


  // массив kef обрабатываем в соответствии с выбранными исходами - res
  for (let i=0; i<max; i++) {
    if (+res[i]===2) kef[i]=1;
    else if (+res[i]===3) kef[i]=0;
  }

  // формируем выигрышные сочетания
  let qwe = factorial(max);
  let a = [];
  for ( let i = 1; i<=qwe; i++) {
    let t=i.toString(2);
    let sum=0;
    for(let j=1; j<=(t.length); j++) {
      sum=sum+t.charAt(j-1)*1;
    }
    if ((+sum) === (+size)) {
      let b=[];
      for (let j=1; j<=max-t.length; j++) {
        b.push(0);
      }
      for(let j=1; j<=t.length; j++) {
        b.push(t.charAt(j-1));
      }
      a.push(b);
    }
    if (a.length>=c) break;
  }

  let dataArr = a;
  // расчеты
  for (let i=0; i<dataArr.length; i++) {
    for (let j=0; j<dataArr[i].length; j++) {
      if (+a[i][j]===0) {
        dataArr[i][j]=' ';
      } else {
        dataArr[i][j] = a[i][j]*kef[j];
      }
    }
  }

  let totalSumArr=[]; // столбец произведений
  let itemBet = bet / c;

  let totalWinning = 0;
  for(let i=0; i<c; i++) {
    let r=dataArr[i];
    let pr=1;
    for (let j=0; j<r.length; j++) if (r[j]!==' ') {
      pr=pr*r[j];
    }
    if (pr > 2000) {
      pr = 2000;
    }
    let ress = round(pr) * round(itemBet);
    totalSumArr.push(round(ress));
    totalWinning += ress;
  }

  let totalCofArr = [];

  for (let i=0; i<dataArr.length; i++) {
    let buff = 1;
    for (let j=0; j<dataArr[i].length; j++) {
      if (dataArr[i][j]!==" ") {
        buff *= dataArr[i][j];
      }
    }

    if (buff > 2000) {
      totalCofArr.push(round(2000));
    } else {
      totalCofArr.push(round(buff));
    }
  }

  return {
    dataArr,
    kefStatus: kef,
    kefArray,
    totalSumArr,
    totalCofArr,
    totalWinning,
    itemBet
  }
};
